import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { LogoDe } from '../composants/Logo'
import { api, lire, requetes } from '../api'
import { SectionConsignesFournisseur } from '../composants/ConsignesFournisseur'
import { Vide } from '../composants/Section'
import { EntetePage } from '../composants/Ui'
import { LIBELLES_ROLE_TIERS } from '../libelles'

/** Fiche d'un tiers : ce que le référentiel en sait, et ses consignes (plusieurs endroits). */
export function TiersFiche({ id }: { id: string }) {
  const tiers = useQuery({
    queryKey: ['tiers', id],
    queryFn: () => lire(api.tiers[':id'].$get({ param: { id } })),
  })
  const entites = useQuery(requetes.entites).data ?? []
  if (tiers.isPending) return <Vide>Chargement…</Vide>
  if (!tiers.data)
    return (
      <main>
        <p className="alerte">Tiers introuvable.</p>
        <Link to="/tiers">Retour aux tiers</Link>
      </main>
    )
  const t = tiers.data
  const parDefaut = entites.find((e) => e.id === t.entiteParDefautId)?.nom
  return (
    <main>
      <EntetePage
        surtitre={LIBELLES_ROLE_TIERS[t.role]}
        titre={t.nom}
        logo={<LogoDe nom={t.nom} taille={36} />}
      />
      <section className="carte section">
        <p className="discret">
          {[
            parDefaut ? `Entité par défaut : ${parDefaut}` : 'Sans entité par défaut',
            t.siren && `SIREN ${t.siren}`,
            t.adressesMail.length > 0 && t.adressesMail.join(', '),
          ]
            .filter(Boolean)
            .join(' · ')}
        </p>
        <Link to="/tiers">Tous les tiers</Link>
      </section>
      <SectionConsignesFournisseur tiersId={t.id} />
    </main>
  )
}
